export const STANDARD_GRAPH_HEIGHT = 400
